import { render, staticRenderFns } from "./WorkflowItem.vue?vue&type=template&id=217944f8&scoped=true&"
import script from "./WorkflowItem.vue?vue&type=script&lang=js&"
export * from "./WorkflowItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkflowItem.vue?vue&type=style&index=0&id=217944f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217944f8",
  null
  
)

export default component.exports